export default __webpack_public_path__ + "alberta-fab-checkbox-off.4ccd8827dd1dad81011e.svg";